import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { OrderDocumentsComponent } from '../../../pages/secure/order/order-documents/order-documents.component';
import { CmrStatus } from '../../objects/enum/cmrStatus';
import { DocumentStatus } from '../../objects/enum/documentStatus';
import { Order } from '../../objects/order/order';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.css'],
  standalone: false,
})
export class UploadDocumentComponent {
  @Output() closeUpload = new EventEmitter<boolean>();
  @Input('order') order: Order;
  @Input() docStatus: DocumentStatus;
  documentStatus = DocumentStatus;

  constructor(private modalService: ModalService) {}

  uploadDocuments(
    orderId: string,
    cmrStatus: CmrStatus,
    customerId: number,
  ): void {
    const orderDocumentModalRef = this.modalService.open(
      OrderDocumentsComponent,
      {
        centered: true,
        size: 'lg',
        container: '#AppContent',
      },
    );
    orderDocumentModalRef.componentInstance.orderId = orderId;
    orderDocumentModalRef.componentInstance.orderCmrStatus = cmrStatus;
    orderDocumentModalRef.componentInstance.customerId = customerId;
    orderDocumentModalRef.componentInstance.editMode = false;
    orderDocumentModalRef.result.catch(() => {
      this.modalService.close();
      this.closeUpload.next(true);
    });
  }
}
